import Image from 'next/image'

const Account = ({ t }) => {
  return (
    <>
      <h3 className='font-light text-[30px] md:text-[28px] my-6'>
        {t('account.title')}
      </h3>
      <p className='font-normal mb-6'>
        {t('account.change-notification-preferences')}
      </p>
      <p className='font-light mb-6'>
        {t.rich('account.change-notification-preferences-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image114.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('account.change-notification-preferences-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image116.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>
        {t('account.complete-personal-profile')}
      </p>
      <p className='font-light mb-6'>
        {t.rich('account.complete-personal-profile-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image118.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('account.complete-personal-profile-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image120.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>{t('account.change-password')}</p>
      <p className='font-light mb-6'>
        {t.rich('account.change-password-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image122.gif'
          alt=''
          width={619}
          height={366}
          quality={100}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-light mb-6'>
        {t.rich('account.change-password-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image137.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('account.change-password-step-3', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image125.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-normal mb-6'>
        {t('account.complete-company-profile-admin')}
      </p>
      <p className='font-light mb-6'>
        {t.rich('account.complete-company-profile-admin-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image127.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>

      <p className='font-light mb-6'>
        {t.rich('account.complete-company-profile-admin-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image129.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <div className='mb-6'>
        <p className='font-light'>
          {t.rich('account.logo', {
            bold: (chunks) => <span className='font-normal'>{chunks}</span>,
          })}
        </p>
        <p className='font-light'>
          {t.rich('account.address', {
            bold: (chunks) => <span className='font-normal'>{chunks}</span>,
          })}
        </p>
        <p className='font-light'>
          {t.rich('account.taxNumber', {
            bold: (chunks) => <span className='font-normal'>{chunks}</span>,
          })}
        </p>
      </div>

      <p className='font-normal mb-6'>{t.rich('account.invite-new-members')}</p>
      <p className='font-light mb-6'>
        {t.rich('account.invite-new-members-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image131.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('account.invite-new-members-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image133.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>
        {t('account.remove-member-account-Admin')}
      </p>
      <p className='font-light mb-6'>
        {t.rich('account.remove-member-account-Admin-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-12'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image135.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-normal mb-6'>{t('account.delete-account')}</p>
      <p className='font-light mb-6'>
        {t.rich('account.delete-account-step-1', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image122.gif'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
      <p className='font-light mb-6'>
        {t.rich('account.delete-account-step-2', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <div className='mb-6'>
        <Image priority={true}
          src='https://storage.googleapis.com/rolzo-static-bucket/faq/image136.png'
          alt=''
          width={619}
          height={366}
          className='w-[75%] h-auto'
        />
      </div>
    </>
  )
}

export default Account
